import { t } from "../i18n/index.ts";
import { darkColors, setDarkColors } from "../lib/documents.ts";
import { appDark } from "../lib/theme.ts";
import { DarkIcon } from "./icons.tsx";
import { iconButtonClass } from "./styles.ts";

/**
 * "Dark colors": a document's (or a PDF's) colours turned for a dark screen, kept in this browser for all of them. A moon in
 * the viewer's bar, pressed when on; only while the app itself is dark (on a light one, a document is as printed).
 */
export function DarkToggle() {
  if (!appDark.value) {
    return null;
  }
  const on = darkColors.value;
  return (
    <button
      type="button"
      class={iconButtonClass("xs")}
      aria-pressed={on}
      aria-label={t("office.darkColors")}
      title={t("office.darkColors")}
      onClick={() => setDarkColors(!on)}
    >
      <DarkIcon />
    </button>
  );
}
